// extracted by mini-css-extract-plugin
export default {"wrapper":"regt4E","double":"zmhVZH","mobile":"sulPtJ","single":"MpJ3wS","image":"NRxv9Y"};